const {EXPIRATION} = require('./cache/cached');
const Fetcher = require('./fetcher');
const Cache = require('./cache/cache');

class CachedFetcher {
    constructor() {
        this.fetcher = Fetcher.create();
        this.cache = new Cache();
    }

    clear() {
        this.cache.clear();
    }

    performGet(url = '') {
        return this.fetcher.get(url);
    }

    get(url = '') {
        const cached = this.cache.get(url, EXPIRATION.PRELOAD);
        return cached.valid ? cached.data : this.performGet(url);
    }

    cacheGet(url, expiration) {
        const promise = this.get(url);
        this.cache.push({url, expiration, promise});
        return promise;
    }

    getOnce(url = '') {
        const cached = this.cache.get(url, EXPIRATION.NEVER);
        return cached.valid ? cached.data : this.cacheGet(url, EXPIRATION.NEVER);
    }

    getAlways(url = '') {
        this.cache.delete(url);
        return this.get(url);
    }

    preload(url = '') {
        return this.cacheGet(url, EXPIRATION.PRELOAD);
    }

    post(url = '', data = {}) {
        return this.fetcher.post(url, data);
    }

    put(url = '', data = {}) {
        return this.fetcher.put(url, data);
    }
}

module.exports = new CachedFetcher();
